import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { DuplicateProductRequest } from '@nucleus-commerce/api-client/admin';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** A taken handle (409 on `body.handle`) is shown on the dialog's field, not toasted. */
export function useDuplicateProduct(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: DuplicateProductRequest) => productsApi.duplicate(productId, body),
    meta: { successMessage: 'products:toasts.duplicated', silentError: true },
    onSuccess: (product) => {
      queryClient.setQueryData(productKeys.detail(product.id), product);
      return queryClient.invalidateQueries({ queryKey: productKeys.lists() });
    },
  });
}
